import BaseService from './_base.service';

export const countryService = {
    page,
    edit,
    combo,
    create,
    one,
    remove,
    removeLogic
};

function page(page,size, callback) {
    return BaseService.get("/country/page/"+page+"/"+size, callback, true)
}
function combo(callback) {
    return BaseService.get("/country/combo/", callback, true)
}
function edit(id, bodyelement, callback) {
    let body = JSON.stringify(bodyelement)
    return BaseService.put("/country/"+id, body, callback, true)
}

function create(bodyelement, callback) {
    let body = JSON.stringify(bodyelement)
    return BaseService.post("/country/", body, callback, true)
}

function one(id,callback) {
    return BaseService.get("/country/one/"+id, callback);
}

function remove(id,callback) {
    return BaseService.delete("/country/"+id, callback);
}

function removeLogic(id,callback) {
    return BaseService.delete("/country/"+id+"/logic", callback);
}
